
import { EventType } from './event.type';

/**
 *
 * @class Event
 *
 * base class for KRPano events
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class Event {

  /** the kind of event */
  private _type: EventType = EventType.NONE;

  /** milliseconds since epoch */
  private _time: number = 0;

  /** the KRPano "direct" API */
  private _krpano: any  = null;

  /** standard constructor */
  constructor(krpano : any, type : EventType = EventType.NONE) {

    this._krpano = krpano;
    this._type   = type;
    this._time   = Date.now();
  }

  /** fetch the event type */
  type(): EventType {

    return this._type;
  }

  /** fetch the timestamp */
  time(): number {

    return this._time;
  }

  krpano(): any {

    return this._krpano;
  }

}
